export enum FileStatus {
  OK = 'OK',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  ERROR = 'ERROR',
}
